<template>
  <div class="l-header">
    <div class="l-header__top" :class="{ 'l-header__sub': isSubHeader }">
      <section class="l-header__top__inner">
        <div class="l-header__top__logo">
          <CMS
              contents_type="block_contents"
              location_code="BS_TOP_01_001-TOP_LOGO"
          />
        </div>
        <div v-if="showHeaderContent" class="l-header__top__menu">
          <ul class="l-header__menu__list l-header__menu__list--lg">
            <li class="l-header__menu__item">
              <a
                :href="domainMypage + '/mypage/coupon?sort=displayFrom'"
                class="l-header__menu__item__link"
              >
                <div>
                  <Icon name="mycoupon" />
                </div>
                <p>マイクーポン</p>
              </a>
            </li>
            <li v-if="isLogin && isShowSupplementaryCoupon" class="l-header__menu__item">
              <a
                :href="domainMypage + '/mypage/coupons'"
                class="l-header__menu__item__link"
              >
              <div>
                <Icon name="auxiliarycoupon" />
              </div>
              <p>補助クーポン</p>
              </a>
            </li>
            <li class="l-header__menu__item">
              <a
                :href="domainMypage + '/mypage/favorites'"
                class="l-header__menu__item__link"
              >
              <div>
                <Icon name="favorite_border" />
              </div>
              <p>お気に入り</p>
              </a>
            </li>
            <li class="l-header__menu__item " v-if="isLogin">
              <div class="l-header__menu__item__points">
                <a
                  v-if="showCafe && userData.cafePoint >= 0"
                  :href="domainCafe"
                  class="l-header__menu__item__link l-header__menu__item__points__contents"
                  target="_blank"
                >
                  <div>カフェ</div>
                  <span class="l-header__menu__item__cafe">{{
                    formatNumber(userData.cafePoint)
                  }}</span>
                  <div>P</div>
                </a>
                <a
                  :href="domainMypage + '/mypage/benepo?currentID=0'"
                  class="l-header__menu__item__link l-header__menu__item__points__contents"
                >
                  <div>ベネポ</div>
                  <span class="l-header__menu__item__benepo">{{ 
                    formatNumber(userData.totalPoint) 
                  }}</span>
                  <div>P</div>
                </a>
              </div>
            </li>
            <li
              v-if="isLogin"
              class="l-header__menu__item"
              tabindex="0"
              @click="isUserInfoMenus = true"
              @keyup.enter="isUserInfoMenus = !isUserInfoMenus"
            >
              <div v-if="userData.ssoPrincipalFlg == 1" class="l-header__menu__item__label--self">
                本人
              </div>
              <div v-if="userData.ssoPrincipalFlg == 0" class="l-header__menu__item__label--family">
                家族
              </div>
              <p
                v-if="userData.familyName || userData.firstName"
                class="l-header__menu__list__text"
                wovn-ignore
              >
                <span>{{ userName }}</span>様
              </p>
              <p v-else class="l-header__menu__list__text" wovn-ignore>
                氏名未設定
              </p>
              <UserMenus
                :isShow="isUserInfoMenus"
                @hide="isUserInfoMenus = false"
              />
            </li>
            <li v-if="!isLogin">
              <a class="c-button__login" :href="redirectUrl">ログイン</a>
            </li>
          </ul>
          <div class="l-header__menu__list l-header__menu__list--bottom flex">

            <!-- ログインアイコン -->
            <div v-if="!isLogin" class="l-header__menu__item hidden pr-0 mr-5 sm:block">
              <a
                :href="redirectUrl"
                class="l-header__menu__item__link flex items-center justify-between flex-col"
              >
                <div class="w-6 h-6 text-center">
                  <Icon name="login" />
                </div>
                <p class="header__label --login text-2xs font-bold">ログイン</p>
              </a>
            </div>

            <!-- ハンバーガメニュー -->
            <div class="l-header__menu__list--sm">
              <a
                tabindex="0"
                @keyup.enter="toggleDrawerMenu"
                @click="toggleDrawerMenu"
              >
                <div>
                  <template v-if="isDrawerMenus">
                    <Icon
                      name="navigation_close"
                      width="24px"
                      height="24px"
                      style="vertical-align: middle"
                    />
                    <p class="text-2xs font-bold">閉じる</p>
                  </template>
                  <template v-else>
                    <Icon
                      name="navigation_hamburger"
                      width="24px"
                      height="24px"
                      style="vertical-align: middle"
                    />
                    <p class="text-2xs font-bold">メニュー</p>
                  </template>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- SPドロワーメニュー -->
    <HeaderDrawer
      :isShow="isDrawerMenus"
      @hide="isDrawerMenus = false"
      :isShowSupplementaryCoupon="isShowSupplementaryCoupon"
      :isLogin="isLogin"
      :isShowCafeteriaPoint="isShowCafeteriaPoint"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import _ from 'lodash'
import HeaderDrawer from '@/components/HeaderDrawer'
import UserMenus from '@/components/UserMenus'
import Icon from '@/components/Icon'
import { SAVE_INFO_USER } from '@/store/modules/bs_app/actions'
import { bus } from '@/main'

export default {
  components: {
    HeaderDrawer,
    UserMenus,
    Icon
  },
  props: {
    isShowSupplementaryCoupon:{
      type: Boolean,
      default: false
    },
    isShowCafeteriaPoint:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDrawerMenus: false,
      isUserInfoMenus: false,
      isSearch: false,
      isSubHeader: false
    };
  },
  computed: {
    showCafe() {
      return this.isShowCafeteriaPoint;
    },
    domainTop() {
      return process.env.VUE_APP_TOP_DOMAIN;
    },
    domainMypage() {
      return process.env.VUE_APP_MYPAGE_DOMAIN;
    },
    domainCafe() {
      const cafeUrl = process.env.VUE_APP_CAFE_SYS_URL;
      return cafeUrl;
    },
    /**
     * ログインユーザー情報を取得して返却する
     * @return {object} - ログインユーザー情報のオブジェクト
     */
    userData() {
      if (!this.$auth || !this.$auth.user) return "";
      return this.$auth.user;
    },
    /**
     * ログインユーザー名を登録状況ごとに結合して返却する
     * @return {string} - ログインユーザー名のテキスト
     */
    userName() {
      if (!this.userData) {
        return "";
      } else if (this.userData.familyName && this.userData.firstName) {
        return this.userData.familyName + " " + this.userData.firstName;
      } else {
        return this.userData.familyName || this.userData.firstName;
      }
    },
    /**
     * ユーザーがログインしているかどうかを判定する
     * @return {boolean} - ログインしているかどうか
     */
    isLogin() {
      if (this.$auth.loggedIn) return true;
      return false;
    },
    /**
     * ヘッダーメニューの本体部分を表示するかどうかを判定する
     * @return {boolean} - ヘッダーメニューの本体部分を表示するかどうか
     */
     showHeaderContent() {
      if (typeof this.$route.meta.isShowHeaderContent !== "boolean")
        return true;
      this.isShowHeaderContent = this.$route.meta.isShowHeaderContent;
      return this.isShowHeaderContent;
    },
    /**
     * ログインページからのリダイレクトするためのURLを生成して返却する
     * @return {string} - ログインページからのリダイレクトするためのURLテキスト
     */
    redirectUrl() {
      return (
        process.env.VUE_APP_AUTHORIZATION + "/v1/stay/login"
      );
    },
    /**
     * 現在のページのpathを取得して返却する
     * @return {string} - 現在のページのpathテキスト
     */
    currentpath() {
      return this.$route.path;
    },
  },
  created() {
    if (this.$store.getters["auth/get"].authenticate) {
      this.$modal.open("LoginGuidanceModal");
      this.$store.commit("auth/set", { authenticate: false });
    }
    if (this.isLogin) {
      this.getCafePoint();
    }
  },
  methods: {
    /**
     * 現在フォーカスしているHTML要素からフォーカスを外す
     */
    blur() {
      document.activeElement.blur();
    },
    search() {
      window.alert("Not Implemented");
    },
    /**
     * ハンバーガーメニューの表示非表示を切り替える
     */
    toggleDrawerMenu() {
      if (window.innerWidth > this.$config.responsiveWidth) return false;
      this.isDrawerMenus = !this.isDrawerMenus;
    },
    /**
     * サブヘッダーの表示の有無を判定するフラグをストアから取得する
     */
    getSubHeaderFlg() {
      this.isSubHeader = this.$page.isSubHeader;
    },
    async getProfileInfo() {
      const profile = await this.$repositories('user').getUser()
      if (profile?.data) {
        this.$store.commit('auth/setProfileMe', profile.data)
        this.userId = get(profile.data, 'email', null)
        this.personInfo = profile.data
        this.customerName = this.personInfo.familyName + this.personInfo.firstName
        const userInfo = this.$store.getters['auth/get'].user
        if (!this.memberNo) {
          this.memberNo = get(userInfo, 'ssoCustomerNo', null)
        }
      }

      const pointHistory = await this.$repositories('user').getPointHistory({
        commandType: 1
      })
      if (pointHistory?.data) {
        this.$auth.points = get(pointHistory, 'data.totalPoint') || 0
        const infoUser = {
          memberNo: this.memberNo,
          username: this.customerName,
          userId: this.userId,
          point: this.$auth.points
        }
        this.$store.dispatch(SAVE_INFO_USER, infoUser)
      }
    },
    async getCafePoint() {
      this.$repositories("user")
        .getCafePoint()
        .then((response) => {
          const cafePoint = _.get(response, "data.appliablePoint");
          this.$auth.cafePoint = cafePoint;
        });
    },
    formatNumber(value) {
      return value != null ? new Intl.NumberFormat().format(value) : "";
    },
  },

  mounted() {
    if (this.isLogin) {
      this.getProfileInfo()
    }
    this.$nextTick(() => {
      this.getSubHeaderFlg();
    });
    bus.$on('changeFullName', this.getProfileInfo)
  },
  beforeDestroy() {
    bus.$off('changeFullName')
  },
  watch: {
    $route(from, to) {
      this.isDrawerMenus = false;
      this.isUserInfoMenus = false;
      this.isSearch = false;
      if (this.$store.getters["auth/get"].authenticate) {
        this.$modal.open("LoginGuidanceModal");
        this.$store.commit("auth/set", { authenticate: false });
      }
      if (from.path != to.path) {
        if (this.showCafe) {
          this.getCafePoint();
        }
      }
      this.$nextTick(() => {
        this.getSubHeaderFlg();
      });
    }
  }
};
</script>

<style lang="scss">
@import './style.scss';

%button {
  position: relative;
  display: inline-block;
  border: none;
  line-height: 1.25;
  text-align: center;
  cursor: pointer;
  color: $black;
  &:active {
    transform: translate(0px, 1px);
  }
  &:hover {
    text-decoration: none;
  }
}
.c-button__login {
  @extend %button;
  padding: 0.45rem 0.75rem;
  font-size: 0.625rem;
  padding: 0.8rem 1rem;
  font-size: 0.8rem;
  font-weight: bold;
  color: #fff;
  border-radius: 2px;
  background-color: $black;
  background-color: $primary;
  &:hover {
    background-color: #434547;
    color: #fff;
  }
  @include mq() {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.header {
  &__label {
    &.--login {
      font-size: 8px;
    }
  }
}

.text-2xs {
  font-size: 10px;
}

@media only screen and (max-width: 638px) {
  .sm_hidden {
    display: none;
  }
}
</style>